var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('TableApp', {
    ref: "servicolist",
    attrs: {
      "titulo": "Tributações",
      "acaoBtn": "/#/servicos/nova-tributacao",
      "textoBtn": "Nova tributação",
      "api-url": "/tributacaoservico",
      "fields": _vm.fields,
      "classFilterColumn": "descricao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'descricao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar tributação',
            expression: "'Editar tributação'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleEditTributacao(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Excluir tributação',
            expression: "'Excluir tributação'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteTributacao(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };